export default "/arbitrum-logo.abae01ba680d97dacc23a0fb5caa4863.svg";